module.exports = __webpack_public_path__ + "static/media/aid-band-bandage-svgrepo-com.4537a0aa.svg";